export default __webpack_public_path__ + "static/media/ill-kyc-verification.bcee9e71.svg";